import { applicationSettings } from '../application';
import { uniformGrid } from '../settingsHelpers';
import { DIMENSIONS, ITEMS, MS, TS, UNITS } from '../../constants';
const { width, depth, height } = DIMENSIONS;

export default {
  grid: uniformGrid(1),
  defaultFilter: 'sections',
  roomMinDesktop: {
    width: 4600,
    height: 3100,
  },
  roomMinSummary: {
    width: 1000,
    height: 2200,
  },
  roomMinMobile: {
    width: 2200,
    height: 2200,
  },
  distanceBetweenAttachments: 75,
  roomMax: {
    width: 5700,
    height: 3250,
  },
  zoomableScene: false,
  sideWall: true,
  postWidth: 20, // side-panels
  wall: {
    width: {
      min: 1000,
      max: 5700,
    },
    height: {
      min: 2200,
      max: 3250,
    },
    points:
      applicationSettings.uiPlatform === 'kiosk'
        ? [
            { x: 0, y: 0 },
            { x: 4600, y: 0 },
            { x: 4600, y: 2400 },
            { x: 0, y: 2400 },
          ]
        : [
            { x: 0, y: 0 },
            { x: 4000, y: 0 },
            { x: 4000, y: 2650 },
            { x: 0, y: 2650 },
          ],
    pointsMobilePortrait: [
      { x: 0, y: 0 },
      { x: 2400, y: 0 },
      { x: 2400, y: 2650 },
      { x: 0, y: 2650 },
    ],
    pointsMobileLandscape: [
      { x: 0, y: 0 },
      { x: 5700, y: 0 },
      { x: 5700, y: 2650 },
      { x: 0, y: 2650 },
    ],
    pointsTablet: [
      { x: 0, y: 0 },
      { x: 3900, y: 0 },
      { x: 3900, y: 2650 },
      { x: 0, y: 2650 },
    ],
  },
  canvasMargins: { top: 0, right: 0 },
  canvasMarginsKiosk: { top: 0, right: 0 },
  canvasMarginsMobile: {
    top: 0,
    right: 0,
  },
  canvasMarginsPortraitPercentual: {
    mobile: 0,
    tablet: 0,
  },
  displaySectionMeasurements: false,
  mountingRails: {
    white: {
      1250: '50459208',
      650: '70459207',
    },
    darkGrey: {
      1250: '80460955',
      650: '60460956',
    },
  },
  sectionSnappingDistance: 50,
  showMultipleErrors: true,
  dynamicWallLimits: true,
  measurements: {
    productsRemap: [],
    displayMeasurement: [
      {
        affects: [ITEMS.SECTION],
        rules: {
          measure: false,
          display: true,
          measurementPrefix: false,
          format: `${width}${TS}${depth}${TS}${height} ${MS}`,
          unit: UNITS.cm,
        },
      },
      {
        affects: [
          ITEMS.SECTION,
          ITEMS.CLOTHES_RAIL,
          ITEMS.SHELF,
          ITEMS.DRAWER,
          ITEMS.BASKET,
          ITEMS.SHOE_SHELF,
        ],
        rules: {
          measure: true,
          display: true,
          measurementPrefix: true,
          format: `${width} ${MS}, ${height} ${MS}, ${depth} ${MS}`,
          unit: UNITS.cm,
        },
      },
    ],
  },
  hideInfoIconForType: [],
  bulkArticles: {},
  colorCodes: {
    white: '#F8F8F7',
    dark_grey: '#696664',
  },
};
